import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useCallback } from 'react';
import FormContext from '../../form-context';

var RenderElement = function RenderElement(_ref) {
  var _ref$render = _ref.render,
      render = _ref$render === void 0 ? function () {
    return null;
  } : _ref$render,
      _ref$preview = _ref.preview,
      preview = _ref$preview === void 0 ? false : _ref$preview,
      value = _ref.value,
      onChange = _ref.onChange,
      setShowStepButton = _ref.setShowStepButton;

  var _useContext = useContext(FormContext),
      form = _useContext.form;

  var memoedRender = useCallback(render, [render]);
  return memoedRender(preview, form, value, onChange, setShowStepButton);
};

RenderElement.formItemPropsHandler = function (_ref2) {
  var render = _ref2.render;
  return {
    previewFormater: function previewFormater(value) {
      return _jsx(RenderElement, {
        render: render,
        preview: true,
        value: value
      });
    },
    fullRow: true,
    required: false
  };
};

export default RenderElement;